module.exports = __webpack_public_path__ + "static/media/直销行业解决方案.a2749df2.png";